import type {
  AgencyDto,
  CreateAgencyRequestDto,
  GetAgenciesResponseDto,
  RemoveAgencyResponseDto,
  ReorderAgencyDivisionsRequestDto,
  UpdateAgencyRequestDto,
} from 'shared/dtos/agencies.dto';

import { ApiService } from 'services/api.service';

export default class AgenciesService extends ApiService {
  public getAgencies = async (): Promise<GetAgenciesResponseDto> => {
    return await this.get(`/agencies`);
  };

  public getAgenciesWithDivisions =
    async (): Promise<GetAgenciesResponseDto> => {
      return await this.get(`/agencies?withDivisions=true`);
    };

  public getAgency = async (id: number): Promise<AgencyDto> => {
    return await this.get(`/agencies/${id}`);
  };

  public removeAgency = async (
    id: number,
  ): Promise<RemoveAgencyResponseDto> => {
    return await this.remove(`/agencies/${id}`);
  };

  public createAgency = async (
    formData: CreateAgencyRequestDto,
  ): Promise<AgencyDto> => {
    const requestBody = {
      title: formData.title,
      description: formData.description,
      PeopleId: formData.PeopleId,
    };

    return await this.post('/agencies', requestBody);
  };

  public updateAgency = async (
    id: number,
    formData: UpdateAgencyRequestDto,
  ): Promise<AgencyDto> => {
    const requestBody = {
      title: formData.title,
      description: formData.description,
      PeopleId: formData.PeopleId,
      order: formData.order,
    };

    return await this.put(`/agencies/${id}`, requestBody);
  };

  public reorderAgencyDivisions = async (
    agencyId: number,
    params: ReorderAgencyDivisionsRequestDto,
  ): Promise<AgencyDto> => {
    const { divisionId, orderInAgencyDivisionsList } = params;
    const requestBody = { divisionId, orderInAgencyDivisionsList };
    return await this.put(
      `/agencies/${agencyId}/reorder-divisions`,
      requestBody,
    );
  };
}
